import { render } from "./ConcursuriList.vue?vue&type=template&id=01b3c7f8"
import script from "./ConcursuriList.vue?vue&type=script&lang=js"
export * from "./ConcursuriList.vue?vue&type=script&lang=js"

import "./ConcursuriList.vue?vue&type=style&index=0&id=01b3c7f8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__